<template>
  <div>
    <DefaultPage id="leadership">
      <div class="hero hero--turq">
        <div class="hero__call">
          <h1 class="hero__call__headline">
            Leadership is Action
          </h1>
          <h2 class="financials-headline-btm">not position</h2>
        </div>
        <!-- shapes -->
          <div class="shape shape--hero circle circle--lead-top-big"></div>
          <div class="shape shape--hero circle circle--lead-top-small"></div>
          <div class="triangle-wrap-lead-top">
            <div class="shape shape--hero triangle triangle--lead-top"></div>
          </div>
          <div class="shape shape--hero squares squares--lead-top">
            <div class="square"></div>
            <div class="square"></div>
          </div>
          <div class="shape shape--hero shape--has-bg dot dot--lead-top"></div>
          <!-- end shapes -->
      </div>
      <VisualDataSection id="board-of-directors"
                         title="Our Board of Directors"
      >
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-center">
            <div class="cell medium-10">
              <div class="grid-container">
                <div class="grid-x grid-margin-x leadership-grid">
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Hugh Francis, III, MD</h4>
                      <h6>CHAIR OF THE BOARD</h6>
                      <p>General and Vascular Surgery</p>
                      <p>Memphis Surgery Associates PC</p>
                      <p>Memphis, Tennessee</p>
                      <p>Director Since 1997</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>John O. Lytle, MD</h4>
                      <h6>VICE CHAIR OF THE BOARD</h6>
                      <p>Orthopedic Surgery</p>
                      <p>South Arkansas Orthopaedic Center</p>
                      <p>Pine Bluff, Arkansas</p>
                      <p>Director Since 2006</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Matthew L. Perkins, MD</h4>
                      <h6>VICE-CHAIR ELECT AND TREASURER OF SVMIC</h6>
                      <p>Internal Medicine and Pediatrics</p>
                      <p>Tennessee Medicine and Pediatrics PC</p>
                      <p>Smyrna, Tennessee</p>
                      <p>Director Since 2008</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Katrina M. Hood, MD</h4>
                      <h6>SECRETARY OF SVMIC</h6>
                      <p>Pediatrics</p>
                      <p>Pediatric and Adolescent Associates PSC</p>
                      <p>Lexington, Kentucky</p>
                      <p>Director Since 2009</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Brady W. Allen, MD</h4>
                      <p>Emergency Medicine</p>
                      <p>Ascension Saint Thomas</p>
                      <p>Nashville, Tennessee</p>
                      <p>Director Since 2020</p>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Robert J. Berkompas, MD</h4>
                      <p>Internal Medicine</p>
                      <p>Saint Thomas Medical Group</p>
                      <p>Nashville, Tennessee</p>
                      <p>Director Since 2010</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Melanie B. Blake, MD</h4>
                      <p>Internal Medicine</p>
                      <p>CHI Memorial</p>
                      <p>Chattanooga, Tennessee</p>
                      <p>Director Since 2018</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Chad T. Couch, MD</h4>
                      <p>Urology</p>
                      <p>President of Northeast Market</p>
                      <p>CEO, Bristol Regional Medical Center</p>
                      <p>Bristol, Tennessee</p>
                      <p>Director Since 2008</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Wayne A. Hudec, MD</h4>
                      <p>General Surgery</p>
                      <p>Ozark Surgical Associates</p>
                      <p>Fayetteville, Arkansas</p>
                      <p>Director Since 2009</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Michael A. McAdoo, MD</h4>
                      <p>Family Medicine</p>
                      <p>Milan Medical Center PC</p>
                      <p>Milan, Tennessee</p>
                      <p>Director Since 2002</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Russell E. Miller, CAE</h4>
                      <p>Chief Executive Officer</p>
                      <p>Tennessee Medical Association</p>
                      <p>Nashville, Tennessee</p>
                      <p>Director Since 2013</p>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>John H. Mize, FCAS, MAAA</h4>
                      <p>President and Chief Executive Officer</p>
                      <p>SVMIC</p>
                      <p>Brentwood, Tennessee</p>
                      <p>Director Since 2013</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Craig A. Myers, MD</h4>
                      <p>Obstetrics/Gynecology</p>
                      <p>Generations OB/GYN</p>
                      <p>Knoxville, Tennessee</p>
                      <p>Director Since 2021</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Antwan D. Robinson, MD</h4>
                      <p>Clinical Cardiology</p>
                      <p>Jackson Clinic, PA</p>
                      <p>Jackson, Tennessee</p>
                      <p>Director Since 2002</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Elise E. Schriver, MD</h4>
                      <p>Pulmonary and Critical Care Medicine</p>
                      <p>University Pulmonary and Critical Care</p>
                      <p>Knoxville, Tennessee</p>
                      <p>Director Since 2002</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Jane M. Sneed, MD</h4>
                      <p>Pediatrics</p>
                      <p>The Children’s Clinic</p>
                      <p>Jonesboro, Arkansas</p>
                      <p>Director Since 2013</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Lisa J. Young, MD</h4>
                      <p>Invasive Cardiology</p>
                      <p>Sutherland Cardiology Clinic, Inc.</p>
                      <p>Germantown, Tennessee</p>
                      <p>Director Since 2013</p>
                    </div>
                  </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
      <VisualDataSection id="committees"
                         title="Committees of the Board"
                      >
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-center">
            <div class="cell medium-10">
              <div class="grid-container">
                <div class="grid-x grid-margin-x committee-grid">
                  <div class="cell medium-6 large-4 committee-grid__block">
                    <div class="committee-grid__block__section">
                      <h3>Arkansas Advisory Committee</h3>
                      <p>Wayne A. Hudec, MD, <span class="bold">Chair</span> </p>
                      <p>John G. Elders, MD</p>
                      <p>Patrick J. Flaherty, DO</p>
                      <p>Keitha D. Holland, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>Juan C. Roman, MD</p>
                      <p>Jane M. Sneed, MD </p>
                      <p>Dennis B. Yelvington, MD</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Audit Committee</h3>
                      <p>Katrina M. Hood, MD, <span class="bold">Chair</span></p>
                      <p>Melanie B. Blake, MD</p>
                      <p>Lisa J. Young, MD</p>
                      <p>David A. Curbo, CPA *</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Budget Committee</h3>
                      <p>Michael A. McAdoo, MD, <span class="bold">Chair</span></p>
                      <p>Robert J. Berkompas, MD</p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>Matthew L. Perkins, MD </p>
                      <p>Elise E. Schriver, MD</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Claims Management Core Committee</h3>
                      <p>Elise E. Schriver, MD, <span class="bold">Chair</span></p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>John O. Lytle, MD</p>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 committee-grid__block">
                    <div class="committee-grid__block__section">
                      <h3>Claims Management Committee Consultants</h3>
                      <p>Jon S. Cohen, MD</p>
                      <p>Daniel S. Ely, MD</p>
                      <p>Keith L. Goldberg, MD</p>
                      <p>Brian M. Jerkins, MD</p>
                      <p>Robert H. Miller, II, MD</p>
                      <p>J. Philip Moyers, MD</p>
                      <p>Alan P. Mullins, MD</p>
                      <p>Frank J. Murabito, MD</p>
                      <p>David J. Soll, MD</p>
                      <p>Jane M. Thomas, MD</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Compensation Committee</h3>
                      <p>Michael A. McAdoo, MD, <span class="bold">Chair</span></p>
                      <p>Robert J. Berkompas, MD</p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>Matthew L. Perkins, MD</p>
                      <p>Elise E. Schriver, MD</p>
                      <p>Kye Hudson *</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Executive Committee</h3>
                      <p>John O. Lytle, MD, <span class="bold">Chair</span></p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>Katrina M. Hood, MD</p>
                      <p>John H. Mize, FCAS, MAAA</p>
                      <p>Matthew L. Perkins, MD</p>
                      <p>Elise E. Schriver, MD</p>
                    </div>
                  <div class="committee-grid__block__section">
                      <h3>Investment Committee</h3>
                      <p>Matthew L. Perkins, MD, <span class="bold">Chair</span></p>
                      <p>Robert J. Berkompas, MD</p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>Michael A. McAdoo, MD</p>
                      <p>Elise E. Schriver, MD</p>
                  </div>
                </div>
                  <div class="cell medium-6 large-4 committee-grid__block">
                    <div class="committee-grid__block__section">
                      <h3>Risk Management Committee</h3>
                      <p>Elise E. Schriver, MD, <span class="bold">Chair</span></p>
                      <p>J. Michelle Allmon, MD </p>
                      <p>Michael S. Dolan, MD</p>
                      <p>Daniel S. Ely, MD</p>
                      <p>JimBob Faulk, MD</p>
                      <p>Scott R. Fowler, MD</p>
                      <p>Hugh Francis, III, MD </p>
                      <p>Katrina M. Hood, MD </p>
                      <p>Charles S. Joels, MD </p>
                      <p>John O. Lytle, MD</p>
                      <p>Antwan D. Robinson, MD</p>
                      <p>Matthew P. Willis, MD</p>
                  </div>
                    <div class="committee-grid__block__section">
                      <h3>Succession Planning Committee</h3>
                      <p>Hugh Francis, III, MD, <span class="bold">Chair</span></p>
                      <p>John O. Lytle, MD</p>
                      <p>John H. Mize, FCAS, MAAA</p>
                      <p>Michael A. Ricciardelli, CPA</p>
                      <p>Elise E. Schriver, MD</p>
                      <p>Kye Hudson *</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Underwriting Committee</h3>
                      <p>Chad T. Couch, MD, <span class="bold">Chair</span></p>
                      <p>Brady W. Allen, MD</p>
                      <p>Robert J. Berkompas, MD</p>
                      <p>Mark E. Bigler, MD</p>
                      <p>Ravi D. Chauhan, MD</p>
                      <p>Anthony T. Everhart, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>Benjamin L. Huff, MD</p>
                      <p>Shauna Lorenzo-Rivera, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>Clinton A. Marlar, MD</p>
                      <p>Ryan D. Mire, MD</p>
                      <p>Craig A. Myers, MD</p>
                      <p>Matthew L. Perkins, MD</p>
                      <p>Jason A. Weaver, MD</p>
                      <p>Lisa J. Young, MD</p>
                    </div>
                  </div>
                </div>
                <p class="t-pad-30" style="font-size:12px;">* Non-Member Consultant</p>
              </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
      <VisualDataSection id="officers"
                         title="Our Officers"
                      >
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-center">
            <div class="cell medium-10">
              <div class="grid-container">
                <div class="grid-x grid-margin-x leadership-grid">
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Hugh Francis, III, MD</h4>
                      <h6>Chair of the Board</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>John O. Lytle, MD</h4>
                      <h6>Vice Chair of the Board</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Matthew L. Perkins, MD</h4>
                      <h6>Vice Chair-Elect and Treasurer of the Board</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Katrina M. Hood, MD</h4>
                      <h6>Secretary of the Board</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>John H. Mize, FCAS, MAAA</h4>
                      <h6>President and Chief Executive Officer</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Michael A. Ricciardelli, CPA</h4>
                      <h6>Chief Financial Officer</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Stephen A. Dickens, JD, FACMPE</h4>
                      <h6>Vice President,</h6>
                      <h6>Medical Practice Systems</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Sherie L. Edwards, JD, MBA</h4>
                      <h6>Vice President,</h6>
                      <h6>Corporate and Legal</h6>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Joseph J. Lebryk</h4>
                      <h6>Vice President,</h6>
                      <h6>Business Development</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Andy Meyers</h4>
                      <h6>Vice President,</h6>
                      <h6>Information Systems</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Kenneth W. Rucker, JD</h4>
                      <h6>Vice President,</h6>
                      <h6>Claims</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Charmy M. Shrode</h4>
                      <h6>Vice President,</h6>
                      <h6>Underwriting</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Rochelle E. Weatherly, JD</h4>
                      <h6>Vice President,</h6>
                      <h6>Risk Education and Evaluation Services</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Jackie P. Boswell, MBA, FACMPE</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Medical Practice Services</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Robin Buter, BSN, RN, LNCC</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Evaluation Services</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Dan Himmelberg, JD</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Claims</h6>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Julie Loomis, RN, JD</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Risk Education</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Judy Musgrove</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Marketing and Communications</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Deborah D. Rose, RN, LNC</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Medical Information Services</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Alisa S. Wamble, JD</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Claims</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Tom Werner, FCAS, MAAA</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Actuarial and Business Analytics</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Patrick McBride, CPA</h4>
                      <h6>Director,</h6>
                      <h6>Financial Reporting and Assistant Corporate Secretary</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Renee A. Lewis</h4>
                      <h6>Director,</h6>
                      <h6>Claims Operations and Assistant Corporate Secretary</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Jessica Elston</h4>
                      <h6>Controller</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
    </DefaultPage>
  </div>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import VisualDataSection from '@/components/section/VisualDataSection';

export default {
  name: 'Leadership',
  components: {
    VisualDataSection,
    DefaultPage
  }
};
</script>
